import React from 'react';
import { Card } from 'react-bootstrap';

const ThisPeriodNewLicencesCard = ({ loading, count }) => {
  return (
    <Card className="mb-2">
      <Card.Body>
        <Card.Title className="fs-6">新規ライセンス数（選択期間）</Card.Title>
        <div className="fs-2 fw-bold">
          {loading ? '...' : count}
        </div>
        <div className="small text-muted">
          {/* Licence.createdAt ベースの件数 */}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ThisPeriodNewLicencesCard;
